<router-outlet></router-outlet>
<div id="loader" *ngIf="(loader.isLoaderShowing$ | async)">
  <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
</div>
<!-- <ai-ui-footer></ai-ui-footer> -->